import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { useSelector } from 'react-redux';
import './appBar.css';
import { RootState } from '../../redux/store';
import { useNavigate } from 'react-router-dom';


const UnauthorizedAppbar = () => {
    const navigate = useNavigate();
    const title = useSelector((state: RootState) => state.unauthorizedHeaderTitleSlice.header);
    const parentRoute = useSelector((state: RootState) => state.unauthorizedHeaderTitleSlice.parentRoute);
    const handlePrev = () => {
        if (parentRoute != null) {
            navigate(-1);
        }
    }

    const goToLogin = () => navigate('/login');

    return (
        <>
            <Box sx={{ pb: '63px' }}>
                <AppBar
                    sx={{
                        // maxWidth: MAX_WIDTH_CONTAINER_NotImprotant,
                        background: "#fff",
                        borderLeft: "1px solid #e5e7eb",
                        borderRight: "1px solid #e5e7eb",
                        borderBottom: "#fff",
                        '@media (min-width: 550px)': {

                            background: 'var(--header-color)',

                        },

                    }}
                    className="appBarBackground appbarMedia containerMedia"
                    elevation={3}
                >
                    <Toolbar sx={{ alignItems: "center", height: "100%" }}>


                        <div className="appBarTitle">
                            {parentRoute == null ?
                                <div style={{ display: "flex" }}>
                                    <img src='images/appbarIcon.png' style={{ paddingLeft: "5px", width: "20px", height: "20px" }}></img>
                                    <span className="font-bold text-sm primaryColorLight-900" style={{ fontSize: "15px", color: '#0057CC', alignSelf: "center" }}>{title}</span>
                                </div>
                                : <span className="font-bold text-sm   primaryColorLight-200">{title}</span>}

                        </div>
                        {parentRoute != null ? <IconButton
                            edge="start"
                            color="inherit"
                            className="appBarBackBtn, primaryColorLight-200"
                            onClick={handlePrev}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                            : <div style={{ display: "flex", padding: "2px 7px 2px 5px" }} onClick={goToLogin}>
                                <span className="font-bold text-sm " style={{ fontSize: "15px", paddingTop: "3px", color: '#0057CC' }}>ورود/ثبت نام</span>
                                {/* <PersonIcon style={{ color: "#0057CC" }}></PersonIcon> */}
                            </div>}
                    </Toolbar>
                </AppBar>
            </Box>
            {/* <hr className="separator" /> */}
        </>
    );
};
export default UnauthorizedAppbar;
